import { useTranslation } from "react-i18next";

const OurJourney = () => {
  const { t } = useTranslation();

  return (
    <article className="py-20">
      <div className="w-11/12 mx-auto">
        <h1 className="text-[32px] font-bold text-mainBlue text-center my-4">
          {t("ourJourney")}
        </h1>

        <section className="rtl:pr-12 ltr:pl-12 rtl:border-r-4 ltr:border-l-4 border-mainRed">
          <div className="space-y-8 about-us-counter-wrapper">
            <div className="relative about-us-counter">
              <h2 className="text-[20px] text-mainRed font-bold">2002</h2>
              <p className="text-mainGray">{t("ourJourney")}</p>
            </div>
            <div className="relative about-us-counter">
              <h2 className="text-[20px] text-mainRed font-bold">2002</h2>
              <p className="text-mainGray">{t("startedLandTransportation")}</p>
            </div>
            <div className="relative about-us-counter">
              <h2 className="text-[20px] text-mainRed font-bold">2022</h2>
              <p className="text-mainGray">{t("expandedCustomClearance")}</p>
            </div>
            <div className="relative about-us-counter">
              <h2 className="text-[20px] text-mainRed font-bold">2025</h2>
              <p className="text-mainGray">{t("coveredCountries")}</p>
            </div>
            <div className="relative about-us-counter">
              <h2 className="text-[20px] text-mainRed font-bold">2036 ({t("goal")})</h2>
              <p className="text-mainGray">{t("strongPresence")}</p>
            </div>
          </div>
        </section>
      </div>
    </article>
  );
};

export default OurJourney;
